/**
 * Created by Bart Decorte
 * Date: 2019-06-28
 * Time: 11:08
 */
import Page from '../Page';

export default class WebsitesGenerate extends Page {
  constructor() {
    super();
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Websites/WebsitesGenerate.js